var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 2.5L11.6663 6.66667M15.833 2.5H12.4997M15.833 2.5V5.83333M9.16634 13.3333V18.3333M6.66634 15.8333H11.6663M5.83301 9.16667C5.83301 10.0507 6.1842 10.8986 6.80932 11.5237C7.43444 12.1488 8.28229 12.5 9.16634 12.5C10.0504 12.5 10.8982 12.1488 11.5234 11.5237C12.1485 10.8986 12.4997 10.0507 12.4997 9.16667C12.4997 8.28261 12.1485 7.43477 11.5234 6.80964C10.8982 6.18452 10.0504 5.83333 9.16634 5.83333C8.28229 5.83333 7.43444 6.18452 6.80932 6.80964C6.1842 7.43477 5.83301 8.28261 5.83301 9.16667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderIcon);
export default __webpack_public_path__ + "static/media/gender-icon.a48af36034a0f20cd72a3440db6738c9.svg";
export { ForwardRef as ReactComponent };